import React, { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Tooltip from '../../components/Tooltip';
import { IoSettingsOutline } from 'react-icons/io5';
import FormBuilder from '../../components/formBuilder';
import { useProperty } from '../../hooks/useProperty';
import { useUser } from '../../hooks/useUser';
import { useParams } from 'react-router-dom';

function CriteriaPopupForm({ schema }) {
  const [isOpen, setIsOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const { propertyId } = useParams();
  const { propertyData } = useProperty();
  const { userDocData } = useUser();

  useEffect(() => {
    if (submitted) {
      setIsOpen(false);
    }
  }, [submitted]);

  return (
    <>
      <button
        type="button"
        className="absolute top-2 right-2"
        onClick={() => setIsOpen(true)}
      >
        <Tooltip
          text="Customize your investment criteria for this property (global criteria settings can be accessed on the 'criteria' page)."
          offset="-left-32 -top-16"
        >
          <IoSettingsOutline className="text-primary text-2xl hover:text-primary-500 " />
        </Tooltip>
      </button>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          static
          open={isOpen}
          onClose={() => setIsOpen(false)}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300 opacity-30"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-neutral-900 bg-opacity-90 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              {/* max-w-3xl */}
              <div className="inline-block w-full max-w-2xl my-16 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg">
                <Dialog.Title
                  as="h3"
                  className="text-3xl font-medium p-6 border-b border-neutral-50 text-neutral-900"
                >
                  {schema.name}
                </Dialog.Title>
                <FormBuilder
                  formSchema={schema.schema}
                  formType={schema.formType}
                  data={{ ...userDocData, ...propertyData }}
                  docId={propertyId}
                  setSubmitted={setSubmitted}
                />
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default CriteriaPopupForm;
